import axios from 'axios';
import ENV from "../config";
const getVessels =  async(param1) => {
  try {
    const response = await axios.get(ENV.backend+ '/api/survey/vessels', {
    //const response =  await axios.get('http://44.207.146.240/api/list-cms-bucket-contents', {
     // params: {
       
       // companyName: param1
      //},
    });

    if (response.status === 200) {
      console.log(response.data)
      return response.data;
    } else {
      throw new Error('Failed to retrieve vessels objects');
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default getVessels;
